import angular, { IQService } from 'angular'
import { InsufficientStateForOfflineError } from '../constants'
import { PosStateManager } from '../managers/pos-state-manager'
import { WebRegisterStatusManager } from '../managers/web-register-status-manager'

/**
 * Configure the resource wrapper for resolving the active user
 *
 * @module config.active-user-config
 */
angular.module('webregister').config(function (vdActiveUserProvider: $TSFixMe) {
  vdActiveUserProvider.addResourceWrapper([
    '$q',
    'VdUserModel',
    'webRegisterStatusManager',
    'posStateManager',
    function (
      $q: IQService,
      VdUserModel: $TSFixMe,
      webRegisterStatusManager: WebRegisterStatusManager,
      posStateManager: PosStateManager
    ) {
      /**
       * Loads the active user from the posStateManager saved in memory.
       *
       * @private
       * @method _loadUserFromPosState
       *
       * @return {Promise<User>} A promise resolved with the currently logged in user or rejected if there is no logged
       *         in user ID or no user could be found with that ID
       */
      function _loadUserFromPosState() {
        return $q((resolve, reject) => {
          const user = posStateManager.getUser()

          if (user) {
            resolve(new VdUserModel(user))
          } else {
            reject(
              new InsufficientStateForOfflineError('No logged in user found')
            )
          }
        })
      }

      return function (fetchUser: $TSFixMe) {
        return webRegisterStatusManager.init().then(() => {
          if (webRegisterStatusManager.isOnline()) {
            return fetchUser().catch(() => _loadUserFromPosState())
          }

          return _loadUserFromPosState()
        })
      }
    },
  ])
})
